import React from 'react';
import PropTypes from 'prop-types';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import {
  TotalCentroCustoWrapper,
  LancamentosTotalGeral,
  LancamentosTotalGeralItem,
  LancamentosTotalGeralDivider,
  Totais,
  Total,
  TabelaTotalGeral,
} from './styles';

function CostCenterTotals({ costCenter, isSingleCostCenter }) {
  if (!costCenter.totalSection) {
    return null;
  }

  const isSingleCooperator = costCenter.totalSection.cooperatorsCount === 1;

  if (isSingleCooperator || isSingleCostCenter) {
    return null;
  }

  const creditFunds = costCenter.totalSection.creditFunds ? Object.values(costCenter.totalSection.creditFunds) : [];
  const debitFunds = costCenter.totalSection.debitFunds ? Object.values(costCenter.totalSection.debitFunds) : [];
  const cooperativeActs = costCenter.totalSection.cooperativeActs
    ? Object.values(costCenter.totalSection.cooperativeActs)
    : [];

  return (
    <TotalCentroCustoWrapper>
      <h2 className="center-align">
        <b>
          Total centro de custo: {costCenter.key} – {costCenter.description}
        </b>
      </h2>
      <LancamentosTotalGeral>
        <LancamentosTotalGeralItem>
          <h4 className="center-align">
            <b>Créditos</b>
          </h4>
          <table width="100%">
            <tbody>
              {creditFunds.map((fund) => (
                <tr key={fund.key}>
                  <td>{fund.key}</td>
                  <td>{fund.description}</td>
                  <td>{moneyFormat(fund.amount)}</td>
                  <td className="right-align">{moneyFormat(fund.value)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </LancamentosTotalGeralItem>
        <LancamentosTotalGeralDivider>&nbsp;</LancamentosTotalGeralDivider>
        <LancamentosTotalGeralItem>
          <h4 className="center-align">
            <b>Débitos</b>
          </h4>
          <table width="100%">
            <tbody>
              {debitFunds.map((fund) => (
                <tr key={fund.key}>
                  <td>{fund.key}</td>
                  <td>{fund.description}</td>
                  <td>{moneyFormat(fund.amount)}</td>
                  <td className="right-align">{moneyFormat(fund.value)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </LancamentosTotalGeralItem>
      </LancamentosTotalGeral>
      <Totais>
        <Total>
          <b>Total de Vencimento:</b> {moneyFormat(costCenter.totalSection.totalCredit)}
        </Total>
        <Total>
          <b>Total de Desconto:</b> {moneyFormat(costCenter.totalSection.totalDebit)}
        </Total>
        <Total>
          <b>Total de Cooperados:</b> {costCenter.totalSection.cooperatorsCount}
        </Total>
        <Total>
          <b>Total Líquido do Centro de Custo:</b> {moneyFormat(costCenter.totalSection.netTotal)}
        </Total>
      </Totais>
      {cooperativeActs.length > 0 && (
        <TabelaTotalGeral>
          <tbody>
            {cooperativeActs.map((ato) => (
              <tr key={ato.key}>
                <td>{ato.key}</td>
                <td>{ato.description}</td>
                <td>{moneyFormat(ato.value)}</td>
              </tr>
            ))}
          </tbody>
        </TabelaTotalGeral>
      )}
    </TotalCentroCustoWrapper>
  );
}

CostCenterTotals.propTypes = {
  costCenter: PropTypes.shape({
    key: PropTypes.string,
    description: PropTypes.string,
    totalSection: PropTypes.shape({
      cooperatorsCount: PropTypes.number,
      totalCredit: PropTypes.number,
      totalDebit: PropTypes.number,
      netTotal: PropTypes.number,
      creditFunds: PropTypes.objectOf(
        PropTypes.shape({
          key: PropTypes.string,
          description: PropTypes.string,
          amount: PropTypes.number,
          value: PropTypes.number,
        })
      ),
      debitFunds: PropTypes.objectOf(
        PropTypes.shape({
          key: PropTypes.string,
          description: PropTypes.string,
          amount: PropTypes.number,
          value: PropTypes.number,
        })
      ),
      cooperativeActs: PropTypes.objectOf(
        PropTypes.shape({
          key: PropTypes.string,
          description: PropTypes.string,
          value: PropTypes.number,
        })
      ),
    }),
  }).isRequired,
  isSingleCostCenter: PropTypes.bool,
};

CostCenterTotals.defaultProps = {
  isSingleCostCenter: false,
};

export default CostCenterTotals;
